import styled, { css } from 'styled-components';

import { breakpoint } from 'DesignLibrary/global';
import { FadeOutKeyframes, FadeInKeyframes } from 'DesignLibrary/keyframes';

interface MedicareContainerProps {
  isNextClicked: boolean;
}

export const Wrapper = styled.div``;

export const MedicareContainer = styled.div<MedicareContainerProps>`
  opacity: 0;
  animation: ${FadeInKeyframes} 1s 2.75s forwards;
  background: white;
  padding: 2rem;
  border-radius: 1rem;
  position: relative;
  box-shadow: 0px 2px 8px 0px rgba(47, 47, 82, 0.16);
  width: 100%;
  margin-bottom: 4.5rem;

  ${breakpoint.TABLET} {
    padding: 4rem 0 4rem 4rem;
    margin-bottom: 8rem;
    border-radius: 1rem 0 0 1rem;
    width: 200%;
  }

  h2 {
    color: var(--colors-art-darkgreen);
    font-family: 'Gelica', Georgia, serif;
    font-weight: 400;
    font-size: 2.5rem;
    margin-bottom: 3.5rem;
    line-height: 1.2;

    ${breakpoint.TABLET} {
      font-size: 3.75rem;
    }

    span {
      background: linear-gradient(89deg, var(--colors-art-fuchsia) 1.72%, var(--colors-art-orange) 104.84%);
      background-clip: text;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
  }

  .medicare {
    display: flex;
    gap: 2rem;
    flex-direction: column;

    ${breakpoint.TABLET} {
      max-width: 50%;
      gap: 1rem;
    }

    ${breakpoint.TABLET} {
      flex-direction: row;
      align-items: center;
    }

    div.text {
      ${breakpoint.TABLET} {
        max-width: 70%;
      }
    }

    div.img {
      ${breakpoint.TABLET} {
        max-width: 30%;
      }
    }

    img {
      max-width: 510px;
      margin-bottom: 0;
      width: 100%;
    }

    .button.primary {
      padding: 1rem 2rem 1.1rem;
      font-size: 1.25rem;
      font-weight: 400 !important;
      background: var(--colors-alex-gold80);
      border: 3px solid var(--colors-alex-gold90);
      border-bottom-width: 8px;
      border-radius: 0.5rem;
      box-shadow:
        0px 10px 10px 0px rgba(0, 0, 0, 0.06),
        0px 0px 12px 0px rgba(0, 0, 0, 0.1);
      height: auto;
      max-height: none;
      width: auto !important;
      display: inline-flex;

      &:hover {
        background: var(--colors-alex-gold90);
        border-color: var(--colors-alex-gold);
      }

      &:active {
        border-bottom-width: 3px;
        background: var(--colors-alex-gold80);
        margin-top: 5px;
      }
    }
  }

  ${({ isNextClicked }) =>
    isNextClicked &&
    css`
      opacity: 1;
      animation-name: ${FadeOutKeyframes};
      animation-duration: 0.5s;
      animation-delay: 0s;
    `}
`;
